'use strict';

import axios from 'axios';

const PATERN_HOST = location.protocol.indexOf('https') !== -1 ? /(https:\/\/|www\.)\S+/i : /(http:\/\/|www\.)\S+/i;

export default {
  install (Vue, config) {
    const apiUrl = config && config.apiUrl ? config.apiUrl : '';

    const instance = new Vue();
    const Util = instance.$util;
    const Message = instance.$message;

    const Services = {
      options (url) {
        return _http('get', url + '/fields');
      },

      get (url, id) {
        return _http('get', url, id);
      },

      post (url, data) {
        return _http('post', url, data);
      },

      put (url, data) {
        return _http('put', url, data);
      },

      patch (url, data) {
        return _http('patch', url, data);
      },

      delete (url, id) {
        return _http('delete', url, id);
      },

      remove (url, id) {
        return this.delete(url, id);
      },

      list (url, query) {
        query = query ? '?' + Util.serialize(query) : '';
        return _http('get', url + query);
      },

      save (url, data) {
        return _http(data.id ? 'put' : 'post', url, data);
      }
    };

    function getUrl (url, id) {
      id = (typeof id === 'string' || typeof id === 'number') ? `${id}` : typeof id === 'object' && id.id ? `${id.id}` : '';
      if (url[url.length - 1] !== '/' && id.length > 1) {
        id = `/${id}`;
      }
      return PATERN_HOST.test(url) ? (url + id) : apiUrl + url + id;
    }

    function _http (method, url, data) {
      url = getUrl(url, data);
      console.group('Petición con DataService:');
      console.info('URL:', method.toUpperCase(), url);
      if (data) {
        console.info('Params:', data);
      }

      let setting = {
        method,
        url
      };

      if (typeof data === 'object' && Object.keys(data).length) {
        delete data.id;
        setting.data = data;
      }

      return axios(setting)
      .then(response => filterResponse(response.data))
      .catch(error => handlingErrors(error));
    }

    function filterResponse (response) {
      let data = response.data || response.datos || response;
      console.info('Respuesta:');
      if (Util.toType(data) === 'array') {
        if (window.navigator.appName === 'Netscape') {
          console.log('firefox');
          console.table(data);
        } else {
          console.table(data.map(item => [item]));
        }
      } else {
        console.dir(data);
      }
      console.groupEnd();
      return response;
    }

    function handlingErrors (error) {
      if (error.response) {
        let data = error.response.data;
        Message.error(data.message || 'Error desconocido del servidor');
        console.error(data.message || 'Error desconocido del servidor');
      } else {
        console.error(error.message || 'Error desconocido');
      }
    }

    Vue.prototype.$service = Services;
    Vue.prototype.$http = axios;
    Vue.prototype.$apiUrl = apiUrl;
  }
};



// WEBPACK FOOTER //
// ./src/lib/service.js